/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type PackApprovalStatus =
    (typeof PackApprovalStatus)[keyof typeof PackApprovalStatus];

export const PackApprovalStatus = {
    NotSubmitted: 'NotSubmitted',
    InReview: 'InReview',
    ChangesRequired: 'ChangesRequired',
    Approved: 'Approved',
} as const;
